module.exports = __webpack_public_path__ + "static/media/mockup_12.2aa63fd6.jpg";